import { render, staticRenderFns } from "./SelectOccupation.vue?vue&type=template&id=1178de78&"
import script from "./SelectOccupation.vue?vue&type=script&lang=js&"
export * from "./SelectOccupation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormLabel: require('/workspace/components/Form/FormLabel.vue').default})
